import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import FlagsMixin from './mixins/flags';
import ValidateMixin from './mixins/validate';
import FieldMethodMixin from './mixins/fieldMethod';
export default {
  name: buildComponentName('Form'),
  mixins: [FlagsMixin, ValidateMixin, FieldMethodMixin],
  props: {
    prefixCls: {
      type: String,
      default: 'ux-form'
    },
    layout: {
      type: String,
      default: 'horizontal',
      validator: function validator(val) {
        return ['horizontal', 'vertical', 'inline'].indexOf(val) > -1;
      }
    },
    hideRequiredMark: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fields: []
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          layout = this.layout,
          hideRequiredMark = this.hideRequiredMark;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(layout || 'horizontal'), true), _defineProperty(_ref, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _ref;
    },
    bindAttrs: function bindAttrs() {
      var $attrs = this.$attrs;

      var r = _objectSpread({}, $attrs, {
        novalidate: true
      });

      return r;
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onSubmit = this.onSubmit;
      return _objectSpread({}, $listeners, {
        submit: onSubmit
      });
    }
  },
  created: function created() {
    var validator = this.validator,
        $validator = this.$validator;
    var globalValidator = validator || {};
    var locale = globalValidator.locale;

    if (locale) {
      $validator.locale(locale);
    }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('submit', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        classes = this.classes,
        bindAttrs = this.bindAttrs,
        bindListeners = this.bindListeners;
    return h("form", _mergeJSXProps([{}, {
      class: classes,
      attrs: bindAttrs,
      on: bindListeners
    }]), [$slots.default]);
  }
};